<template>
  <el-dialog title="申请入驻" center :close-on-click-modal="false" :visible.sync="dialogVisible" width="696px"
    @close="handleClose">
    <div class="flex justify-between items-center px-[60px] ">
      <div>
        <p><img class="w-[34px] mx-auto" src="../assets/img/img11.png" alt=""></p>
        <p class="text-[#A11710] pt-[5px]">填写材料</p>
      </div>
      <p>
        <i class="icon  ">&#xe646;</i>
      </p>
      <div :class="{ active: step == 1 }">
        <p v-if="step == 1"><img class="w-[34px] mx-auto" src="../assets/img/img12.png" alt=""></p>
        <p v-else><img class="w-[34px] mx-auto" src="../assets/img/img13.png" alt=""></p>
        <p class="pt-[5px]" :class="{ 'text-[#A11710]': step == 1 }">资质审核</p>
      </div>
      <p>
        <i class="icon  ">&#xe646;</i>
      </p>
      <div>
        <p><img class="w-[34px] mx-auto" src="../assets/img/img14.png" alt=""></p>
        <p class="pt-[5px]">系统对接</p>
      </div>
      <p>
        <i class="icon">&#xe646;</i>
      </p>
      <div>
        <p><img class="w-[34px] mx-auto" src="../assets/img/img15.png" alt=""></p>
        <p class="pt-[5px]">成功上线</p>
      </div>
    </div>
    <div class="px-[70px] pt-[40px]">
      <el-form ref="formData" v-if="step == 0" hide-required-asterisk label-suffix="：" :model="formData"
        label-width="0px">
        <el-form-item label="" prop="enterpriseName"
          :rules="[{ required: true, message: '请填写金融机构名称' }, { pattern: /[\u4e00-\u9fa5]{4,}/, message: '请填写金融机构名称' }]">
          <el-input class="w-250" v-model="formData.enterpriseName" placeholder="请填写金融机构名称"></el-input>
        </el-form-item>
        <el-form-item label="" prop="socialCreditCode"
          :rules="[{ required: true, message: '请填写金融机构统一信用代码' }, { pattern: /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/, message: '请输入企业统一信用代码' }]">
          <el-input class="w-250" v-model="formData.socialCreditCode" placeholder="请填写金融机构统一信用代码"></el-input>
        </el-form-item>
        <el-form-item label="" prop="name" :rules="[{ required: true, message: '请填写经办人姓名' }]">
          <el-input class="w-250" v-model="formData.name" placeholder="请填写经办人姓名"></el-input>
        </el-form-item>
        <el-form-item label="" prop="mobile"
          :rules="[{ required: true, message: '请填写经办人联系手机号码' }, { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写经办人联系手机号码' }]">
          <el-input class="w-250" true v-model="formData.mobile" maxlength="11" placeholder="请填写经办人联系手机号码"></el-input>
        </el-form-item>
        <el-form-item label="" prop="captcha" :rules="[{ required: true, message: '请输入图形验证码' }]">
          <div class="flex">
            <div class="flex-1 pr-[10px]">
              <el-input class="" v-model="formData.captcha" placeholder="请输入图形验证码"></el-input>
            </div>
            <div class="w-[100px]">
              <img class="w-[100px] h-[40px]" @click="getCode" :src="imgcaptcha" alt="" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="" prop="smsCode" :rules="[{ required: true, message: '请输入短信验证码' }]">
          <div class="flex">
            <div class="flex-1 pr-[10px]">
              <el-input class="" v-model="formData.smsCode" placeholder="请输入图形验证码"></el-input>
            </div>
            <div class="w-[100px]">
              <el-button @click="handleSend">{{ CountDownStatus ? "发送短信" : `${CountDownNum}/s` }}</el-button>
            </div>
          </div>

        </el-form-item>
        <el-form-item class="text-center pt-[20px]">
          <el-button type="primary" class="w-[350px]  " @click="handleSubmit"> 提交入驻申请 </el-button>
        </el-form-item>
      </el-form>
      <div v-if="step == 1" class="pt-[60px] pb-[100px]">
        <img src="../assets/img/img16.png" class="w-[181px] mx-auto" alt="">
        <div class="text-center pt-[30px]">
          <p>您已成功提交入驻申请，进入资质审核环节  </p>
          <p>请保持经办人联系手机电话畅通</p>
        </div>
      
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { deepCopyRef, encryptDES } from "@/assets/js/utils";
import CountDown from "@/assets/js/countDown";
import SmsSenderCheck from "@/assets/js/SmsSenderCheck";
let smsSenderCheck = new SmsSenderCheck("login");
export default {
  name: 'dg-apply',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      CountDownNum: 60,
      CountDownStatus: true,
      formData:
      // http://api.jfqingdao.com:8080/doc.html#/default/%E5%BC%80%E6%94%BE%E5%B9%B3%E5%8F%B0-%E8%AE%A4%E8%AF%81%E6%A8%A1%E5%9D%97/registUsingPOST
      {
        enterpriseName: "",  // 企业名称 
        mobile: "",  // 手机号 
        name: "",  // 姓名 
        password: "",  // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密 
        captcha: "",  // 短信验证码 
        smsCode: "",  // 短信验证码 
        socialCreditCode: "",  // 企业统一信用代码 
      },
      step: 0,
      imgcaptcha: ''
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },

  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    /**
    * @author 伟健 / 张
    * @name 发送短信
    */
    handleSend() {
      if (!this.countDown.checkStatus()) {
        return;
      }
      smsSenderCheck.check((valid, fn) => {
        if (valid) {
          let hasError = false;
          this.$refs["formData"].validateField(["mobile", "captcha"], (err) => {
            if (err) {
              hasError = true;
              return;
            }
          });
          if (!hasError) {
            ajax.post({
              url: "/openPlatform/common/sendSmsCode",
              data: {
                catchcode: this.formData.captcha, // 图形验证码
                mobile: this.formData.mobile, // 手机号码
              },
              self: this,
              success: (res) => {
                if (res) {
                  Mirror.emit('tips_dg_alert_box', {
                    msg: '发送成功',
                    type: "warning"
                  })
                  this.countDown.start();
                  fn();
                }
              },
              fail: () => {
                this.formData.catchcode = "";
                this.getCode();
              },
            });

          }
        } else {
          Mirror.emit('tips_dg_alert_box', {
            msg: '短信发送频率过快，请稍后再试',
            type: "warning"
          })
          return;
        }
      });

    },
    handleSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          let _registerForm = deepCopyRef(this.formData);
          _registerForm.password = this.generatePassword()
          _registerForm.password = encryptDES(_registerForm.password);
          ajax.post({
            url: '/openPlatform/auth/regist',
            data: _registerForm,
            self: this,
            success: (res) => {
              console.log(res);
              this.step = 1
            },
            fail: () => { },
          })

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      ajax.post({
        url: '/openPlatform/common/getcaptcha',
        data: {},
        self: this,
        success: (res) => {

          this.imgcaptcha = res
        },
        fail: () => { },
      })

    },
    generatePassword() {
      // 定义可用的字符集
      const lowercase = 'abcdefghijklmnopqrstuvwxyz';
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const numbers = '0123456789';
      const specials = '!@#$%^&*()_+-=[]{}<>?';

      // 组合所有字符
      const allChars = lowercase + uppercase + numbers + specials;

      // 确保密码包含至少一个字符来自每个字符集
      let password = [
        lowercase[Math.floor(Math.random() * lowercase.length)],
        uppercase[Math.floor(Math.random() * uppercase.length)],
        numbers[Math.floor(Math.random() * numbers.length)],
        specials[Math.floor(Math.random() * specials.length)]
      ];

      // 填充剩余4个字符
      for (let i = 4; i < 8; i++) {
        password.push(allChars[Math.floor(Math.random() * allChars.length)]);
      }

      // 打乱字符顺序
      password = password.sort(() => Math.random() - 0.5).join('');

      return password;
    },
  },
  mounted() {
    this.getCode();
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "login",
    });
  },
  created() { },
}
</script>
<style scoped></style>
